import type { ResourceConfig } from "../types";

/**
 * 交付管理资源配置
 *
 * 交付管理包含：网站管理、询盘管理、内容管理
 * 权限控制基于 student_access_edges VIEW 定义的学员访问能力。
 */
export const deliveryConfig = {
  displayName: "交付管理",
  category: "delivery",
  permissions: {
    "read:all": {
      label: "查看所有交付内容",
      description: "可以查看系统中所有学员的交付内容（网站、询盘、内容）",
    },
    "write:all": {
      label: "编辑所有交付内容",
      description: "可以编辑系统中所有学员的交付内容",
    },
    "read:assigned": {
      label: "查看自己负责的交付内容",
      description: "只能查看自己负责学员的交付内容",
    },
    "write:assigned": {
      label: "编辑自己负责的交付内容",
      description: "只能编辑自己负责学员的交付内容",
    },
  },
  scopeStrategy: "byStudentAccessEdge",
  navigation: {
    path: "/delivery",
    label: "交付",
    icon: "Package" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    order: 45,
  },
} satisfies ResourceConfig;
